const HIDDEN_SEARCH_ATTRIBUTE_KEYS = new Set(['vendorcode', 'sku', 'need_preposition']);

export const normalizeSearchAttributeKey = (name: unknown): string => (
  String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s\u00a0\u200b-\u200d\ufeff-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
);

const compactSearchAttributeKey = (key: string): string => (
  key.replace(/[^a-z0-9а-яё]/gi, '')
);

export const resolveSearchAttributeName = (attribute: {
  attribute_name?: unknown;
  attribute_code?: unknown;
  name?: unknown;
} | null | undefined): string => {
  const candidates = [attribute?.attribute_name, attribute?.attribute_code, attribute?.name];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim();
    }
  }

  return '';
};

export const isHiddenSearchAttribute = (name: unknown): boolean => {
  const key = normalizeSearchAttributeKey(name);

  if (!key) {
    return false;
  }

  if (HIDDEN_SEARCH_ATTRIBUTE_KEYS.has(key)) {
    return true;
  }

  return compactSearchAttributeKey(key) === 'needpreposition';
};
